import type {
  CarnivalGameState,
  SelectSinAction,
  ValidationResult,
} from "../types";
import { fail, ok, validateActor } from "./common";

export function validateSelectSin(
  state: CarnivalGameState,
  action: SelectSinAction,
): ValidationResult {
  const actor = validateActor(state, action.playerId);
  if (!actor.valid) return actor;

  if (state.phase !== "SECRET_SELECT") {
    return fail("Sins can only be selected during secret selection", {
      phase: state.phase,
    });
  }

  if (state.selectionsByPlayerId[action.playerId] != null) {
    return fail("Player has already selected a sin this round", {
      playerId: action.playerId,
    });
  }

  const hand = state.handsByPlayerId[action.playerId] ?? [];
  if (!hand.includes(action.sin)) {
    return fail("Sin is not in the player's hand", { sin: action.sin, hand });
  }

  return ok;
}
